import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';

import Modal from '../../molecules/modal';
import { useInternalDashboardSelector } from './Selector';
import Button from '../../atom/button';

export const StyledModal = styled(Modal)({
  zIndex: 9999,

  '& .MuiDialog-paper': {
    maxWidth: '1000px',
    borderRadius: '16px',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
  },
});

export const ModalUserMessage = () => {
  const { selectedRow, stopRowAction, isShowUserMessage } = useInternalDashboardSelector();
  const [userMessage, setUserMessage] = useState<string>('');

  useEffect(() => {
    if (selectedRow?.userMessage) {
      setUserMessage(selectedRow?.userMessage);
    } else {
      setUserMessage(''); // No message to show
    }
  }, [selectedRow?.userMessage]);

  return (
    <StyledModal open={isShowUserMessage} title='User Error Message' subtitle='Details' fullWidth onClose={stopRowAction}>
      <div className='relative'>
        <div className='p-24 border-t border-neutral-20'>
          <div className='p-12 rounded-8 bg-neutral-10 border border-neutral-40 font-mono'>{userMessage}</div>
        </div>
        <div className='py-16 px-24 border-t border-neutral-20 flex items-center justify-end'>
          <Button variant='neutral_outline' className='!border-2 !min-w-0 !py-6' onClick={() => stopRowAction()}>
            Close
          </Button>
        </div>
      </div>
    </StyledModal>
  );
};
